module.exports = __webpack_public_path__ + "static/media/watermelon-icon.03b68465.png";